import create from 'zustand';
import { TrainingQueryState } from './interfaces/CreateQueryState';
import { createCommonTrainingQuerySlice } from './slices/TrainingQuerySlices/CommonTrainingQuerySlice';

export const useTrainingQueryStore = create<TrainingQueryState>((set) => ({
  ...createCommonTrainingQuerySlice(set)
}));
